// Financing program details.
export const FINANCING_MIN = 500;
export const FINANCING_MAX = 25000;
export const PREQUALIFY_URL = "https://wisetack.us/#/oz5c20p/prequalify";
export const PROMO_HEADLINE = "6 Months No Interest";

// Accepted payment methods (outside of financing).
export const PAYMENT_METHODS = [
  "All major credit & debit cards",
  "Venmo",
  "Zelle",
  "PayPal",
  "Klarna",
  "Cash & check",
];
